import { useQuery, useQueryClient } from 'react-query';
import { TimeDurationEnum } from 'shared/enums/TimeDurationEnum';
import { filtersService } from 'shared/services/FiltersService';

export const useOrganizations = () => {
    const queryClient = useQueryClient();
    const { data, isLoading, isError, refetch } = useQuery(
        ['organizations'],
        () => filtersService.getOrganizations(),
        {
            onError: (error: Error) => {
                console.log('Error on getting organizations - ', error);
            },
            initialData: () => queryClient.getQueryData(['organizations']),
            staleTime: TimeDurationEnum.HALF_DAY,
        }
    );

    return {
        data,
        isLoading,
        serverErrorMessage: isError,
        refetch,
    };
};
